import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchGetProduct } from "./emailSuiteAPI";

export const getProducts = createAsyncThunk(
  "emailSuite/getProduct",
  async (gid) => {
    const response = await fetchGetProduct(gid);
    return response;
  }
);

const emailSuiteSlice = createSlice({
  name: "emailSuite",
  initialState: {
    status: "",
    error: "",
    titan: "",
    eccs: "",
    gsuite: "",
    microsoft: "",
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProducts.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getProducts.fulfilled, (state, action) => {
        const resData = action.payload.products.product;
        state.status = "fulfilled";
        if (resData[0].gid === "674" || resData[0].gid === 674) {
          state.eccs = resData;
        } else if (resData[0].pid === "74" || resData[0].pid === 74) {
          state.gsuite = resData;
        } else if (resData[0].gid === "705" || resData[0].gid === 705) {
          state.titan = resData;
        } else {
          state.microsoft = resData;
        }
      })
      .addCase(getProducts.rejected, (state, action) => {
        state.status = "error";
        state.error = action.error.message;
      });
  },
});

export default emailSuiteSlice.reducer;
